import React, { Component } from 'react';
import { Modal, message, Spin, Button } from 'antd';
import Fetch from '../../../common/Fetch';
import format from '../../shared/format';
import { getMatchOption } from '../../shared/selectFn';
import autoEval from '../../shared/autoEvaluation';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import UpdateUI from './UpdateUI';
import "../style.less"

let Constants = {};
const getStatusByType = (type) => {
    switch(type) {
        case 'add':
            return {
                add: true,
                title: '添加JDE建号申请',
                saveUrl: API_URL.contract.addJdeApply,
            };
        case 'edit':
            return {
                edit: true,
                title: '修改JDE建号申请',
                saveUrl: API_URL.contract.updateJdeApply,
            }
        case 'copy':
            return {
                copy: true,
                title: '复制新建',
                saveUrl: API_URL.contract.addJdeApply,
            }
    }
};

const initialState = () => ({
    loading: false,
    visible: false,

    sponsorWritable: false,
    proCodeWritable: false,
    customerWritable: false,
    invApplyFinish: false,       // PM申请项目终止

    disease: {},
    saveParams: {},
    investigation: {},

    fileList: [],
    byStageList: [],
    currencyList: [],
    belongingToUnitList: [],
    relationContractList: [],
    evaluateAlert: null,       // 业务机会编号/临床评估单号 已被申请提示弹窗
});

class Update extends Component {
    state = {
        typeList: [],
        testeeTypeList: [],
        ...initialState(),
        inJdeStatus:false,
        rateCanEdit: false,
    }

    dictLoaded = false

    show = (params, type) => {
        // 项目分类字典与项目数据无关，首开一次；请求失败则下次打开自动重试
        if (!this.dictLoaded) {
            this.loadTypeConfigureList();
        }
        const {
            currencyCode,
            initialExpectContractAmount,
            initialContractAmount,
            initialActualExpenseFee,
            initialActualFee,
            initialTaxationFee,
            unitOfSigningId,
            belongingToUnit,
            unitOfBelongingId,
            baName,
            baCode,
            investigationMedicineType: oldMedicineType,
            secondResearchProductType,
            businessOpportunityNum,   // CRM推送数据 列表行业务机会编号
        } = params || {};
        const contractParams = {};
        if (currencyCode !== 'CNY') {
            contractParams.expectContractAmount = initialExpectContractAmount;
            contractParams.contractAmount = initialContractAmount;
            contractParams.actualExpenseFee = initialActualExpenseFee;
            contractParams.actualFee = initialActualFee;
            contractParams.taxationFee = initialTaxationFee;
        }
        contractParams.baUserName = baName && baCode ? `${baName}(${baCode})` : undefined;
        // 修改/复制时 回显已选择的业务机会编号(evaluateCode 由行数据直接带入)
        contractParams.busOppNum = businessOpportunityNum || undefined;
        const { signingUnitList } = this.props;

        Constants = getStatusByType(type);
        this.secondLineIsEmpty = false;

        this.setState({
            visible: true,
            rateCanEdit: type == 'add' ? false : 'rmb',
            saveParams: {
                isClinicalProject: '1',
                ...(params || {}),
                ...contractParams,
                signingUnit: unitOfSigningId,
                belongingToUnit: unitOfBelongingId,
                belongingToUnitName: belongingToUnit,
                investigationMedicineType: secondResearchProductType ? [oldMedicineType , secondResearchProductType] : [oldMedicineType],
            },
            belongingToUnitList: getMatchOption(signingUnitList, 'unitOfSigningId', unitOfSigningId).belongings || [],
        }, () => {
            const { saveParams } = this.state;
            const { investigationId, investigationName, jdeApplySceneId, contractOrLetterIsSign, natureOfContract, jdeApplyIsInvestigationExists } = saveParams;
            const scene1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
            if (Constants.edit || Constants.copy) {
                if (contractOrLetterIsSign == 1) {
                    if (natureOfContract === 'TERMINATION_CONTRACT' || natureOfContract === 'TERMINATION_LETTER') {
                        this.queryInvFinishInfo(investigationId, () => this.loadFileList('CONTRACT'));
                    } else {
                        this.loadFileList('CONTRACT');
                    }
                } else {
                    this.loadFileList('ADVANCE_WORK');
                }
                this.loadInvestigationByStageList();
                jdeApplyIsInvestigationExists == 1 && this.loadInvestigation(investigationName);
                scene1Or2 ? this.queryAllDiseaseList() : this.loadRelationContractList();
            }
            this.loadAllCurrencyExchangeRateList();
        });
    }

    hide = () => {
        this.evaluateSelected = false;   // 是否点击选中了检索下拉候选内容
        this.setState(initialState());
    }

    /**
     * 查询项目终止信息
     * @param {Number} investigationId 项目id
     * @param {Function} callback 回调
     */
    queryInvFinishInfo = (investigationId, callback) => {
        Fetch.post(API_URL.proContract.getInvTerminationApplyInfo, { investigationId })
            .then(res => {
                const { data: { invTerminationApplyId, terminationReason, fileList: terminationFileList } } = res;
                const { fileList, saveParams } = this.state;
                if (invTerminationApplyId) {
                    saveParams.terminationReason = terminationReason;
                    terminationFileList.forEach((item, index) => {
                        const { name, fileMateId, invTerminationApplyId } = item;
                        fileList.push({
                            name,
                            response: { fileMetaId: fileMateId },
                            uid: `${invTerminationApplyId}.${index}`,
                            deletable: false,
                        });
                    });
                }
                this.setState({
                    fileList,
                    saveParams,
                    invApplyFinish: !!invTerminationApplyId,
                }, () => {
                    callback && callback();
                });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询项目
     * @param {String} investigationName 项目名
     */
    loadInvestigation = (investigationName) => {
        Fetch.post(API_URL.investigation.queryInvestigationByName, { investigationName })
            .then(res => {
                const { data } = res;
                this.setState({ investigation: data[0] });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询项目分期
     */
    loadInvestigationByStageList = () => {
        const { saveParams: { investigationMedicineType = [] } } = this.state;
        if (investigationMedicineType[0]) {
            Fetch.post(API_URL.common.queryInvestigationByStageByMedicine, { investigationMedicineType: investigationMedicineType[0] })
                .then(res => {
                    this.setState({ byStageList: res.data }, () => {
                        this.autoEvaluation(false);
                    });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ byStageList: [] });
        }
    }

    /**
     * 查询文件
     * @param {String} uploadType 文件类型
     */
    loadFileList = (uploadType) => {
        const { saveParams: { jdeApplyId } } = this.state;
        Fetch.post(API_URL.contract.queryJdeApplyFileMetaById, {
            jdeApplyId,
            uploadType,
        }).then(res => {
            const { data } = res;
            const { fileList } = this.state;
            data.forEach((item, index) => {
                const { name, fileMateId } = item;
                fileList.push({
                    name,
                    response: { fileMetaId: fileMateId },
                    uid: index,
                    isCopy: Constants.copy,
                });
            });
            this.setState({ fileList });
        }).catch(error => console.log(error));
    }

    /**
     * 查询关联合同
     */
    loadRelationContractList = () => {
        const { saveParams: { investigationId } } = this.state;
        if (investigationId) {
            Fetch.post(API_URL.contract.queryRelationJdeId, { investigationId })
                .then(res => {
                    this.setState({ relationContractList: res.data || [] });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ relationContractList: [] });
        }
    }

    /**
     * 查询汇率
     */
     loadAllCurrencyExchangeRateList = () => {
        Fetch.post(API_URL.contract.queryAllCurrencyExchangeRate)
            .then(res => {
                const { saveParams } = this.state;
                if (Constants.add) {
                    const { exchangeRate, currencyExchangeRateId } = getMatchOption(res.data, 'currencyName', '人民币');
                    saveParams.exchangeRate = exchangeRate;
                    saveParams.currencyExchangeRateId = currencyExchangeRateId;
                }
                this.setState({
                    saveParams,
                    currencyList: res.data,
                });
            })
            .catch(error => console.log(error));
    }

    /**
     * 查询项目分类
     */
    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            Fetch.post(API_URL.common.typeConfigureList)
                .then(cb)
                .catch(error => console.log(error));
        }, res => {
            this.dictLoaded = true;
            this.setState({
                typeList: res.typeList,
                testeeTypeList: res.testeeTypeList,
            });
        });
    }

    /**
     * 业务机会编号/临床评估单号 选择（显示条件: 新增-系统无此项目且临床项目; 修改-场景1或2且临床项目，键入检索见 SearchRetrieve）
     * 一个字段选中 另一个字段自动填充；已被JDE建号申请选择过时弹框提示
     */
    handleEvaluateSelect = (option) => {
        this.evaluateSelected = true;
        const { businessOpportunityNum, evaluateCode, jdeApplyCode } = option || {};
        const { saveParams } = this.state;
        saveParams.busOppNum = businessOpportunityNum;
        saveParams.evaluateCode = evaluateCode;
        this.setState({ saveParams }, () => {
            if (jdeApplyCode) {
                this.setState({
                    evaluateAlert: { businessOpportunityNum, evaluateCode, jdeApplyCode },
                });
            }
        });
    }

    /**
     * 失焦且未选中候选内容时 两个字段同时清空
     */
    handleEvaluateBlur = () => {
        if (!this.evaluateSelected) {
            const { saveParams } = this.state;
            saveParams.busOppNum = undefined;
            saveParams.evaluateCode = undefined;
            this.setState({ saveParams });
        }
        this.evaluateSelected = false;
    }

    /**
     * 已被申请提示-重新选择：清空已选的业务机会编号/临床评估单号
     */
    handleEvaluateReselect = () => {
        const { saveParams } = this.state;
        saveParams.busOppNum = undefined;
        saveParams.evaluateCode = undefined;
        this.setState({ saveParams, evaluateAlert: null });
    }

    /**
     * 已被申请提示-无需重新选择/关闭：仅关闭弹窗
     */
    handleEvaluateAlertClose = () => {
        // 修复误清空：弹窗打开时 Modal 会把焦点从业务机会编号输入框抢到弹窗上，
        // 触发一次失焦，把一次性标记 evaluateSelected 消费掉(复位为 false)；
        // 关闭弹窗后 Modal 又会把焦点返还给业务机会编号输入框，
        // 之后点击 合同或函证是否签署 等其他字段再次失焦时，标记已是 false，
        // handleEvaluateBlur 会把 业务机会编号/临床评估单号 一起误清空。
        // 这里重新置位标记，使弹窗关闭后的首次失焦仍视为"已选中"。
        this.evaluateSelected = true;
        this.setState({ evaluateAlert: null });
    }

    /**
     * 查询疾病
     */
    queryAllDiseaseList = () => {
        const { saveParams: { diseaseName, diseaseId } } = this.state;
        if (diseaseName) {
            Fetch.post(API_URL.common.queryAllDiseaseList, { keyword: diseaseName })
                .then(res => {
                    const { saveParams } = this.state;
                    const disease = getMatchOption(res.data, 'diseaseId', diseaseId);
                    saveParams.investigationAreaName = disease.investigationAreaName;
                    this.setState({
                        disease,
                        saveParams,
                    }, () => {
                        this.autoEvaluation(false);
                    });
                })
                .catch(error => console.log(error));
        } else {
            this.setState({ disease: {} });
        }
    }
     // 关闭申请审批流程中的JDE建号申请所在项目下，不可再添加JDE建号
     inJdeApplyCloseProgress = (investigationId) => {
         Fetch.post(API_URL.investigation.inJdeApplyCloseProgress, { investigationId })
                .then(res => {
                    const { data } = res || {};
                    if(data){
                        message.warning('本项目已经在走关闭流程，不可新建JDE建号申请'); 
                    }
                    this.setState({
                        inJdeStatus:data
                    });
                    
                }).catch(error => console.log(error));
    }

    submit = () => {
        const { businessList } = this.props;
        const {
            saveParams,
            fileList,
            byStageList,
            currencyList,
            sponsorWritable,
            proCodeWritable,
            customerWritable,
            inJdeStatus,
        } = this.state;
        //解决是否据实结算、优惠客户的默认值
        saveParams.isRealitySettle=saveParams.contractOrLetterIsSign == 1? saveParams.isRealitySettle?saveParams.isRealitySettle:0:null;
        saveParams.isMsaSpecialContractReduce=saveParams.isRealitySettle == 0?saveParams.isDiscountTermValidity ==1?saveParams.isMsaSpecialContractReduce?saveParams.isMsaSpecialContractReduce:0:null:null;
        const {
            jdeApplyIsInvestigationExists,
            investigationId,
            isClinicalProject,
            contractOrLetterIsSign,
            natureOfContract,
            relationJdeId,
            // sponsorId,
            contractSignCompanyId,
            investigationIdentifyCodeId,
            customerCompanyId,
            customerProjectCode,
            expectContractAmount,
            contractIsSpecifiesAmount,
            contractAmount,
            rate,
            taxationFee,
            actualExpenseFee,
            actualFee,
            relateJdeIsDeductAmount,
            contractStartDate,
            contractEndDate,
            jdeApplySceneId,
            jdeApplyId,
            lineOfBusiness,
            belongingToUnit,
            signingUnit,
            diseaseId,
            investigationMedicineType = [],
            investigationByStageId,
            investigationByStageRemark,
            testeeTypeId,
            secondLineIds,
            exchangeRate, //汇率
            currencyExchangeRateId,
            terminationReason,
            baUserId,
            customerCompanyName,
            customerCompanySpecialName,
            isRealitySettle=0,
            isMsaSpecialContractReduce=0,
            isMsaSpecialDiscountCustom, //是否优惠客户
            isDiscountTermValidity, //是否有效期内
            discountContractAmount,
            havePaperContract, //是否有纸质合同
        } = saveParams;
        const scene1Or2 = jdeApplySceneId == 1 || jdeApplySceneId == 2;
        const existPro = jdeApplyIsInvestigationExists == 1 && !scene1Or2;
        const contractIsSign = contractOrLetterIsSign == 1;
        const FIRST_CONTRACT = natureOfContract == 'FIRST_CONTRACT';
        const SUPPLEMENT_CONTRACT = natureOfContract == 'SUPPLEMENT_CONTRACT';
        const currencyCode = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId).currencyCode;

        const JDECustomerCompanyNameErr = (contractOrLetterIsSign ==0&&customerCompanyName&&(!customerCompanySpecialName));

        if (!havePaperContract && (havePaperContract +'') !== "0") {
            message.warning('请选择是否有纸质合同');
                return;
        }
        if (!Constants.edit) {
            if (!jdeApplyIsInvestigationExists) {
                message.warning('请选择系统中是否有此项目');
                return;
            }
            if (existPro && !investigationId) {
                message.warning('请选择项目简称');
                return;
            }
            else if(inJdeStatus){
                message.warning('本项目已经在走关闭流程，不可新建JDE建号申请');
                return;
            }
        }
        if (!existPro && !isClinicalProject) {
            message.warning('请选择此项目是否为临床项目');
            return;
        }
        if (!Constants.edit) {
            if (!contractOrLetterIsSign) {
                message.warning('请选择合同或函证是否签署');
                return;
            }
            if (!natureOfContract) {
                message.warning('请选择合同性质');
                return;
            }
        }
        if ((natureOfContract == 'SUPPLEMENT_CONTRACT' || natureOfContract == 'TERMINATION_CONTRACT' || natureOfContract == 'TERMINATION_LETTER') && !contractIsSign) {
            message.warning('选择“补充合同”、“终止合同”或“终止函”时，合同或函证需签署完成！');
            return;
        }
        if (!FIRST_CONTRACT && !relationJdeId) {
            message.warning('请选择关联JDE');
            return;
        }
        // if (!existPro || (!FIRST_CONTRACT && sponsorWritable)) {
        //     if (!sponsorId) {
        //         message.warning('请选择申办方');
        //         return;
        //     }
        // }
        if (!existPro || (!FIRST_CONTRACT && sponsorWritable)) {
            if (!contractSignCompanyId) {
                message.warning('请选择合同签署方');
                return;
            }
        }
        // if(!investigationIdentifyCodeId) {
        //     message.warning('请选择项目识别码');
        //     return;
        // }
        if (!existPro || (!FIRST_CONTRACT && proCodeWritable)) {
            if (!customerProjectCode) {
                message.warning('请输入项目编号');
                return;
            }
        }

        if (FIRST_CONTRACT || SUPPLEMENT_CONTRACT || customerWritable) {
            if (!customerCompanyId) {
                message.warning('请选择客户全名');
                return;
            }
            if(JDECustomerCompanyNameErr){
                message.warning('当前客户未维护客户简称，请联系管理员维护其客户简称');
                return;
            }
        }
        if (!baUserId) {
            message.warning('请选择BA');
            return;
        }
        if (!existPro || scene1Or2) {
            if (!investigationMedicineType || (investigationMedicineType && !investigationMedicineType.length)) {
                message.warning('请选择研究产品类型');
                return;
            } else if (!investigationByStageId) {
                message.warning('请选择项目分期');
                return;
            } else if (getMatchOption(byStageList, 'investigationByStageId', investigationByStageId).investigationByStageName === '其他') {
                if (!investigationByStageRemark) {
                    message.warning('请输入其他项目分期备注');
                    return;
                }
            }
            if (!diseaseId) {
                message.warning('请选择疾病');
                return;
            }
            if (!testeeTypeId) {
                message.warning('请选择受试者类型');
                return;
            }
        }
        //助理审批状态修改(CRM合同生成的JDE建号申请): 系统中已有项目场景受试者类型也必填
        if (existPro && saveParams.jdeApplyStatus == 'ASSISTANT_APPROVAL' && !testeeTypeId) {
            message.warning('请选择受试者类型');
            return;
        }
        if (!lineOfBusiness) {
            message.warning('请选择业务线');
            return;
        }
        const { childList: secondLineList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
        if ((!existPro || this.secondLineIsEmpty) && (secondLineList || []).length && !secondLineIds) {
            message.warning('请选择执行业务线二级分类');
            return;
        }
        if (!signingUnit) {
            message.warning('请选择合同签署单位');
            return;
        }
        if (!belongingToUnit) {
            message.warning('请选择收入归属单位');
            return;
        }
        if (!currencyExchangeRateId) {
            message.warning('请选择币种');
            return;
        }
        if (currencyCode !== 'CNY' && !exchangeRate) {
            message.warning('请输入汇率');
            return;
        }
        if (contractIsSign == 0) {
            if (!(expectContractAmount || expectContractAmount === 0)) {
                message.warning('请输入预计合同金额');
                return;
            } else {
                if (FIRST_CONTRACT && expectContractAmount < 0) {
                    message.warning('合同性质为“首次合同”时，预计合同金额不支持负数');
                    return;
                }
            }
            if (!fileList.length) {
                message.warning('请上传提前上岗授权函');
                return;
            }
            let idx = 0;
            for (let i = 0; i < fileList.length; i++) {
                const { response, deletable } = fileList[i];
                if (!response) {
                    message.warning('文件上传中，请稍后！');
                    return;
                }
                if (deletable === false) {
                    continue;
                }
                saveParams[`arr[${idx++}]`] = response.fileMetaId;
            }
        } else if (contractIsSign == 1) {
            if (!contractIsSpecifiesAmount) {
                message.warning('请选择合同中是否明标合同金额');
                return;
            }
            if (!(contractAmount || contractAmount === 0)) {
                message.warning('请输入合同额含税');
                return;
            } else {
                if (FIRST_CONTRACT && contractAmount <= 0) {
                    message.warning('合同性质为“首次合同”时，合同额含税不支持负数和零');
                    return;
                } else if (!SUPPLEMENT_CONTRACT && contractAmount === 0) {
                    message.warning('合同额含税不支持零');
                    return;
                }
            }
            if (!(taxationFee || taxationFee === 0) || !(rate || rate === 0)) {
                message.warning('请输入合同税率或合同额税费');
                return;
            }
            if (relationJdeId && FIRST_CONTRACT && !relateJdeIsDeductAmount) {
                message.warning('请选择关联JDE是否需要扣除相应金额');
                return;
            }
            if(!isRealitySettle && (isRealitySettle +'') !== "0"){
                message.warning('请选择是否据实结算');
                return;
            }if(!isRealitySettle && isMsaSpecialDiscountCustom &&isDiscountTermValidity &&! isMsaSpecialContractReduce && (isMsaSpecialContractReduce +'') !== "0"){
                message.warning('请选择MSA特殊优惠是否从合同额中扣减');
                return;
            }
            if(isRealitySettle == 0 && isMsaSpecialContractReduce == 1 && !discountContractAmount){
                message.warning('请输入优惠金额（含税）/人民币');
                return;
            }
            if (!contractStartDate) {
                message.warning('请选择合同开始时间');
                return;
            }
            if (!contractEndDate) {
                message.warning('请选择合同结束时间');
                return;
            }
            if ((natureOfContract == 'TERMINATION_CONTRACT' || natureOfContract == 'TERMINATION_LETTER') && !terminationReason) {
                message.warning('请输入项目终止原因！');
                return;
            }
            if (!fileList.length) {
                message.warning('请上传附件');
                return;
            }
            let idx = 0;
            for (let i = 0; i < fileList.length; i++) {
                const { response, deletable } = fileList[i];
                if (!response) {
                    message.warning('文件上传中，请稍后！');
                    return;
                }
                if (deletable === false) {
                    continue;
                }
                saveParams[`ids[${idx++}]`] = response.fileMetaId;
            }
        }
        saveParams.contractStartDate = format('date', contractStartDate);
        saveParams.contractEndDate = format('date', contractEndDate);
        if (Constants.copy) {
            saveParams.jdeApplyId = undefined;
        }

        if (currencyCode === 'CNY') {
            saveParams.initialExpectContractAmount = '';  //预计合同金额（原币）
            saveParams.initialContractAmount = '';  //合同额含税（原币）
            saveParams.initialActualExpenseFee = '';  //实报实销费（原币）
            saveParams.initialActualFee = ''; //实报实销税费(原币)
            saveParams.initialTaxationFee = ''; //税费（原币）
        } else {
            saveParams.initialExpectContractAmount = expectContractAmount;  //预计合同金额（原币）
            saveParams.initialContractAmount = contractAmount;  //合同额含税（原币）
            saveParams.initialActualExpenseFee = actualExpenseFee;  //实报实销费（原币）
            saveParams.initialActualFee = actualFee; //实报实销税费(原币)
            saveParams.initialTaxationFee = taxationFee; //税费（原币）
        }

        const params = {};

        if (currencyCode !== 'CNY') {
            params.expectContractAmount = (expectContractAmount || expectContractAmount === 0) ? (expectContractAmount * exchangeRate).toFixed(2) : '';  //预计合同金额（人民币）
            params.contractAmount = (contractAmount || contractAmount === 0) ? (contractAmount * exchangeRate).toFixed(2) : '';  //合同额含税（人民币）
            params.actualExpenseFee = (actualExpenseFee || actualExpenseFee === 0) ? (actualExpenseFee * exchangeRate).toFixed(2) : '';  //实报实销费（人民币）
            params.actualFee = (actualFee || actualFee === 0) ? (actualFee * exchangeRate).toFixed(2) : ''; //实报实销税费(人民币)
            params.taxationFee = (taxationFee || taxationFee === 0) ? (taxationFee * exchangeRate).toFixed(2) : ''; //税费（人民币）
        }
        params.investigationMedicineType = investigationMedicineType[0];
        params.secondResearchProductType = investigationMedicineType.length === 2 ? investigationMedicineType[1] : undefined;

        // 仅显示业务机会编号/临床评估单号时提交(与显示条件一致):
        // 新增(无jdeApplyId)-系统无此项目且临床项目; 修改(有jdeApplyId)-场景1或2且临床项目
        // 显示时两个字段必填(与页面红色*号一致)
        const showEvaluate = isClinicalProject == 1 && (jdeApplyId ? scene1Or2 : jdeApplyIsInvestigationExists == 0);
        if (showEvaluate) {
            if (!saveParams.busOppNum) {
                message.warning('请选择业务机会编号');
                return;
            }
            if (!saveParams.evaluateCode) {
                message.warning('请选择临床评估单号');
                return;
            }
        } else {
            saveParams.busOppNum = undefined;
            saveParams.evaluateCode = undefined;
        }

        this.setState({ loading: true });
        Fetch.post(Constants.saveUrl, {
            isCopy: Constants.copy,
            ...saveParams,
            ...params,
        }).then(res => {
            message.success(Constants.copy ? '复制新建成功' : res.success);
            this.setState({ loading: false }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(error => {
            console.log(error);
            this.setState({ loading: false });
        });
    }

    handleChange = (value, key, rateCanEdit = true) => {
        const { businessList } = this.props;
        const { saveParams, investigation } = this.state;
        switch(key) {
            case 'jdeApplyIsInvestigationExists': {
                saveParams[key] = value;
                saveParams.natureOfContract = undefined;
                this.setState({ saveParams }, () => {
                    this.handleChange({}, 'disease');
                    this.handleChange(undefined, 'investigationMedicineType');
                    this.handleChange({}, 'investigation');
                });
                break;
            }
            case 'investigation': {
                const {
                    value: investigationId,
                    text: investigationName,
                    isClinicalProject,
                    investigationSponsor,
                    investigationSponsorId,
                    investigationCode,
                    lineOfBusiness,
                    lineOfBusinessString,
                    secondLineIds,
                    secondLineNames,
                    investigationIdentifyCode,
                    investigationIdentifyCodeId,
                    contractSignCompanyId,
                    contractSignCompanyName,
                } = value;
                if(investigationId){
                    this.inJdeApplyCloseProgress(investigationId);
                }
                const { natureOfContract } = saveParams;
                const params = {
                    ...saveParams,
                    investigationId,
                    investigationName,
                    investigationIdentifyCode: investigationIdentifyCode || undefined,
                    investigationIdentifyCodeId: investigationIdentifyCodeId || undefined,
                    isClinicalProject: isClinicalProject != undefined ? isClinicalProject.toString() : undefined,
                    sponsorId: investigationSponsorId || undefined,
                    sponsorName: investigationSponsor || undefined,
                    contractSignCompanyId: contractSignCompanyId || undefined,
                    contractSignCompanyName: contractSignCompanyName || undefined,
                    customerProjectCode: investigationCode || undefined,
                    lineOfBusiness,
                    lineOfBusinessString,
                    secondLineIds: secondLineIds || '',
                    secondLineNames: secondLineNames || '',
                };

                // 项目名称包含遗传办、安全事务，二级业务线自动赋值
                if (investigationName && isClinicalProject == 1 && lineOfBusiness) {
                    let secondLineNames;
                    let { childList } = getMatchOption(businessList, 'typeConfigureId', lineOfBusiness);
                    if (investigationName.includes('遗传办')) {
                        secondLineNames = '遗传办';
                    } else if (investigationName.includes('安全事务')) {
                        secondLineNames = '安全事务';
                    }

                    const { typeConfigureId } = getMatchOption(childList, 'typeValue', secondLineNames);
                    if (typeConfigureId) {
                        params.secondLineIds = typeConfigureId;
                        params.secondLineNames = secondLineNames;
                    }
                }
                
                this.secondLineIsEmpty = !params.secondLineIds;
                this.setState({
                    saveParams: params,
                    investigation: value,
                    sponsorWritable: natureOfContract && natureOfContract !== 'FIRST_CONTRACT' ? !investigationSponsorId : false,
                    proCodeWritable: natureOfContract && natureOfContract !== 'FIRST_CONTRACT' ? !investigationCode : false,
                }, () => {
                    this.loadRelationContractList();
                    this.handleChange(undefined, 'relationJdeId');
                });
                break;
            }
            case 'isClinicalProject': {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.handleChange(undefined, 'lineOfBusiness');
                });
                break;
            }
            case 'sponsor': {
                const { value: id, text: name } = value;
                saveParams.sponsorId = id;
                saveParams.sponsorName = name;
                this.setState({ saveParams });
                break;
            }
            case 'contractSignCompany': {
                const { value: id, text: name } = value;
                saveParams.contractSignCompanyId = id;
                saveParams.contractSignCompanyName = name;
                this.setState({ saveParams });
                break;
            }
            case 'investigationIdentifyCode': {
                const { value: id, text: name } = value;
                saveParams.investigationIdentifyCodeId = id;
                saveParams.investigationIdentifyCode = name;
                this.setState({ saveParams });
                break;
            }
            case 'customerProjectCode': {
                const { jdeApplySceneId, } = saveParams;
                const { blindInvestigationId } = investigation;
                if (
                    (jdeApplySceneId == 1 || jdeApplySceneId == 2) &&
                    !!blindInvestigationId &&
                    ((value || '').includes('遗传办') || (value || '').includes('安全事务'))
                ) {
                    message.warning('已关联盲态项目下，项目编号不可修改为“遗传办”、“安全事务”')
                    return;
                }
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'customerCompany': {
                const { value: id, text: name, customerCompanyCode,customerCompanySpecialName } = value;
                saveParams.customerCompanyId = id;
                saveParams.customerCompanyName = name;
                saveParams.customerJdeCode = customerCompanyCode;
                saveParams.customerCompanySpecialName = customerCompanySpecialName;
                this.setState({ saveParams });
                break;
            }
            case 'contractOrLetterIsSign': {
                saveParams[key] = value;
                saveParams.expectContractAmount = '';
                saveParams.contractAmount = '';
                saveParams.rate = '';
                saveParams.actualExpenseFee = '';
                saveParams.taxationFee = '';
                saveParams.actualFee = '';
                saveParams.relateJdeIsDeductAmount = '';
                saveParams.contractIsSpecifiesAmount = '';
                saveParams.contractStartDate = undefined;
                saveParams.contractEndDate = undefined;
                this.setState({
                    saveParams,
                    fileList: [],
                });
                break;
            }
            case 'natureOfContract': {
                saveParams[key] = value;
                let params = {};
                if (value === 'TERMINATION_CONTRACT' || value === 'TERMINATION_LETTER') {
                    const { investigationId } = saveParams;
                    this.queryInvFinishInfo(investigationId);
                } else {
                    saveParams.terminationReason = undefined;
                    params.fileList = [];
                    params.invApplyFinish = false;
                }
                this.setState({
                    ...params,
                    saveParams,
                }, () => {
                    this.handleChange(undefined, 'relationJdeId');
                });
                break;
            }
            case 'relationJdeId': {
                saveParams[key] = value;
                const { signingUnitList } = this.props;
                let { customerWritable } = this.state;
                const { relationContractList } = this.state;
                const {
                    customerProjectCode,
                    customerCompanyId,
                    customerCompanyName,
                    customerCompanySpecialName,
                    customerJdeCode,
                    unitOfBelongingId,
                    unitOfSigningId,
                    belongingToUnit,
                    isDiscountTermValidity,//是否优惠有效期内
                    isMsaSpecialDiscountCustom,//是否优惠客户
                } = getMatchOption(relationContractList, 'investigationJdeContractId', value);
                const belongingToUnitList = getMatchOption(signingUnitList, 'unitOfSigningId', unitOfSigningId).belongings || [];
                saveParams.customerCompanyId = customerCompanyId || undefined;
                saveParams.customerCompanyName = customerCompanyName || undefined;
                saveParams.customerCompanySpecialName = customerCompanySpecialName || undefined;
                saveParams.customerJdeCode = customerJdeCode || undefined;

                saveParams.signingUnit = unitOfSigningId || undefined;
                saveParams.belongingToUnit = unitOfBelongingId || undefined;
                saveParams.belongingToUnitName = belongingToUnit || undefined;
                saveParams.relateJdeIsDeductAmount = '';

                const DiscountTermValidity = isDiscountTermValidity || undefined;
                const MsaSpecialDiscountCustom = isMsaSpecialDiscountCustom || undefined;
                this.handleChange(DiscountTermValidity , 'isDiscountTermValidity' );
                this.handleChange(MsaSpecialDiscountCustom , 'isMsaSpecialDiscountCustom' );

                customerWritable = value ? !customerProjectCode : false;

                this.setState({
                    saveParams,
                    customerWritable,
                    belongingToUnitList
                });
                break;
            }
            case 'currencyExchangeRateId': {
                saveParams[key] = value;
                const { currencyList = [] } = this.state;
                const { contractOrLetterIsSign } = saveParams;
                const rateItem = getMatchOption(currencyList, 'currencyExchangeRateId', value);
                const { exchangeRate, currencyName, dateShow } = rateItem || {};
                saveParams.exchangeRate = exchangeRate;
                saveParams.currencyExchangeRate = exchangeRate;
                saveParams.currencyName = currencyName;
                saveParams.dateShow = dateShow;
                if (contractOrLetterIsSign != 1) {
                    saveParams.expectContractAmount = '';
                }
                saveParams.contractAmount = '';
                saveParams.rate = '';
                saveParams.actualExpenseFee = '';
                saveParams.taxationFee = '';
                saveParams.actualFee = '';
                this.setState({ saveParams });
                break;
            }
            case 'signingUnit': {
                saveParams[key] = value;
                const { signingUnitList } = this.props;
                const belongingToUnitList = getMatchOption(signingUnitList, 'unitOfSigningId', value).belongings || [];

                if (value && !belongingToUnitList.length) {
                    const { signingUnit: prevSigningUnit } = saveParams || {};
                    saveParams.signingUnit = prevSigningUnit;
                    message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                    return;
                }
                if (belongingToUnitList.length === 1) {
                    saveParams.belongingToUnit = belongingToUnitList[0].unitOfBelongingId;
                    saveParams.belongingToUnitName = belongingToUnitList[0].unitOfBelongingName;
                } else {
                    saveParams.belongingToUnit = undefined;
                    saveParams.belongingToUnitName = undefined;
                }
                this.setState({
                    saveParams,
                    belongingToUnitList,
                });
                break;
            }
            case 'baUser': {
                const { value: id, text: name } = value;
                saveParams.baUserId = id;
                saveParams.baUserName = name;
                this.setState({ saveParams });
                break;
            }
            case 'investigationMedicineType': {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.handleChange([], 'investigationByStageId');
                    this.loadInvestigationByStageList();
                    this.autoEvaluation();
                });
                break;
            }
            case 'investigationByStageId': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || []).slice(-1));
                saveParams.investigationByStageId = isMultipleChoice == 1 ? (value || []).join(',') : `${investigationByStageId || ''}`;
                saveParams.investigationByStageRemark = undefined;
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'disease': {
                const { value: id, text: name, diseaseClassName, investigationAreaId, investigationAreaName, invAreaGroupType } = value;
                saveParams.diseaseId = id;
                saveParams.diseaseName = name ? name.replace(/^(NA)\(.+\)$/, '$1') : undefined;
                saveParams.diseaseClassName = diseaseClassName;
                saveParams.investigationAreaId = investigationAreaId;
                saveParams.investigationAreaName = investigationAreaName;
                saveParams.invAreaGroupType = invAreaGroupType;
                this.setState({
                    saveParams,
                    disease: value,
                }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'testeeTypeId': {
                saveParams[key] = value;
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            }
            case 'lineOfBusiness':
                saveParams.lineOfBusiness = value;
                saveParams.lineOfBusinessString = undefined;
                saveParams.secondLineIds = '';
                this.setState({ saveParams }, () => {
                    this.autoEvaluation();
                });
                break;
            case 'secondLineIds': {
                const { isClinicalProject } = saveParams;
                // 是临床项目时单选
                const singleSelect = isClinicalProject == 1;
                if (singleSelect) {
                    saveParams.secondLineIds = value;
                } else {
                    saveParams.secondLineIds = (value || []).join(',');
                }
                this.setState({ saveParams });
                break;
            }
            case 'isRealitySettle':
                saveParams.isRealitySettle = value;
                if(value == 1){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 0){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialContractReduce':
                saveParams.isMsaSpecialContractReduce = value;
                if(value == 0 ){
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'discountContractAmount':
                if(value){
                    if(typeof(value) == typeof('') && value.substring(0,1) === '-'){
                        saveParams.discountContractAmount = value.slice(1);
                    }
                    else{
                        saveParams.discountContractAmount = value
                    }
                }else{
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
                break;
            case 'isMsaSpecialDiscountCustom'://是否优惠客户
                saveParams[key] = value;
                if( !value || value == 0 ){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'isDiscountTermValidity'://是否优惠有效期
                saveParams[key] = value;
                if(!value || value == 0){
                    saveParams.isMsaSpecialContractReduce = null;
                    saveParams.discountContractAmount = null;
                }else if(value == 1 ){
                    saveParams.isMsaSpecialContractReduce = 0;
                    saveParams.discountContractAmount = null;
                }
                this.setState({ saveParams });
            break;
            case 'rate'://合同税率
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rate' });
            break;
            case 'taxationFee'://合同额税费/人民币
                saveParams[key] = value;
                rateCanEdit && this.setState({ saveParams, rateCanEdit: 'rmb' });
            break;
            default: {
                saveParams[key] = value;
                this.setState({ saveParams });
                break;
            }
        }
    }

    handleDelete = (value, key) => {
        switch (key) {
            case 'relationJdeId':
                if (!value) {
                    this.handleChange(undefined, 'relationJdeId');
                }
                break;
            default:
                break;
        }
    }

    autoEvaluation = (clearSecondLine = true) => {
        const { businessList } = this.props;
        const { byStageList, typeList, testeeTypeList, saveParams, disease } = this.state;
        const {
            jdeApplySceneId,
            jdeApplyIsInvestigationExists,
            isClinicalProject,
            investigationMedicineType,
            investigationByStageId,
            investigationAreaName,
            invAreaGroupType,
            testeeTypeId,
            customerProjectCode
        } = saveParams;

        const params = autoEval({
            type: 'JDE',
            businessList,
            byStageList,
            typeList,
            testeeTypeList,
            disease,
            isClinicalProject,
            investigationMedicineType,
            investigationAreaName,
            invAreaGroupType,
            testeeTypeId,
            jdeApplySceneId,
            jdeApplyIsInvestigationExists,
            investigationByStageId: (investigationByStageId || '').split(','),
            investigationCode: customerProjectCode
        });

        if (clearSecondLine && !params.secondLineNames && (saveParams.lineOfBusiness != params.lineOfBusiness)) {
            params.secondLineIds = '';
            params.secondLineNames = '';
        }
        this.setState({ saveParams: Object.assign(saveParams, params) });
    }

    handleChangeRateCanEdit = value => {
        this.setState({ rateCanEdit: value })
    }

    getDataList = () => {
        const { businessList, signingUnitList } = this.props;
        const {
            saveParams,
            relationContractList,
            sponsorWritable,
            proCodeWritable,
            customerWritable,
            invApplyFinish,
            byStageList,
            currencyList = [], // 币种信息
            belongingToUnitList,
            testeeTypeList,
            fileList = [],
            investigation,
            rateCanEdit,
        } = this.state;
        const settings = {
            Constants,
            saveParams,
            relationContractList,
            sponsorWritable,
            proCodeWritable,
            customerWritable,
            invApplyFinish,
            investigation,
            byStageList,
            businessList,
            currencyList, // 币种信息
            belongingToUnitList,
            fileList,
            testeeTypeList,
            signingUnitList,
            rateCanEdit,
        };
        return (
            <UpdateUI
                {...settings}
                secondLineIsEmpty={this.secondLineIsEmpty}
                handleDelete={this.handleDelete}
                handleChange={this.handleChange}
                beforeUpload={this.beforeUpload}
                handleUploadChange={this.handleUploadChange}
                handleChangeRateCanEdit={this.handleChangeRateCanEdit}
                handleRemove={this.handleRemove}
                handleEvaluateSelect={this.handleEvaluateSelect}
                handleEvaluateBlur={this.handleEvaluateBlur}
            />
        );
    }

    beforeUpload = file => {
        const { fileList = [] } = this.state;
        const isLt30M = file.size / 1024 / 1024 <= 30;
        if (fileList.length >= 10) {
            message.warning('最多上传10个附件');
            return false;
        }
        if (!isLt30M) {
            message.warning('文件大小不能超过30M');
            return false;
        }
    }

    handleUploadChange = (info) => {
        const fileList = info.fileList.filter((file,index) => {
            const { status, response } = file;
            if (status === 'error') {
                message.error('上传附件失败');
                return false;
            } else if (status === 'done') {
                if (response.error) {
                    message.error(response.error);
                    return false;
                } else if(index == info.fileList.length-1){
                    message.success(response.success);
                    return true;
                }
            }
            return true;
        });
        this.setState({ fileList });
    }

    handleRemove = file => {
        const { isCopy, deletable } = file;
        if (isCopy) {
            return;
        } else if (deletable === false) {
            return false;
        }
        Fetch.post(API_URL.contract.deleteJdeCodeEnclosure, {
            fileMetaId: file.response.fileMetaId,
        }).then(res => {
            message.success(res.success);
        }).catch(error => console.log(error));
    }

    render() {
        const { visible, loading, evaluateAlert } = this.state;
        return (
            <div>
                <Modal
                    title={Constants.title}
                    visible={visible}
                    onCancel={this.hide}
                    onOk={this.submit}
                    className="setjde-modal addchildcontract"
                    wrapClassName="vertical-center-modal"
                    bodyStyle={{ maxHeight: 500 }}
                    confirmLoading={loading}
                    maskClosable={false}
                    width="780px"
                >
                    <div className="cont-cont" id="dropdown-position" style={{ position: 'relative', padding: '0 20px' }}>
                        <Spin spinning={loading}>
                            <ul className="preview-list apply-jde">
                                {this.getDataList()}
                            </ul>
                        </Spin>
                    </div>
                </Modal>
                {/* 业务机会编号/临床评估单号 已被申请提示 */}
                <Modal
                    title="提示"
                    visible={!!evaluateAlert}
                    onCancel={this.handleEvaluateAlertClose}
                    maskClosable={false}
                    width="650px"
                    wrapClassName="vertical-center-modal"
                    footer={[
                        <Button key="noNeedReselect" type="primary" onClick={this.handleEvaluateAlertClose}>无需重新选择</Button>,
                        <Button key="reselect" type="primary" onClick={this.handleEvaluateReselect}>重新选择</Button>,
                    ]}
                >
                    <div style={{ fontSize: 16, textAlign: 'center', padding: '0 30px' }}>
                        <p>
                            {evaluateAlert && `业务机会编号${evaluateAlert.businessOpportunityNum}，临床评估单号${evaluateAlert.evaluateCode}`}
                        </p>
                        <p>
                            {evaluateAlert && `已被申请编号${evaluateAlert.jdeApplyCode}添加，是否重新选择？`}
                        </p>
                    </div>
                </Modal>
            </div>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/Update.js